exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".job-details-header-block{display:flex}.job-details-image-container{flex:0 0 110px;margin-right:16px}.job-details-header-container{flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/components/jobdetails/style.css
// module id = 704
// module chunks = 0